/**
 * Ad Server Type
 */
define([], function () {
  var adServerType = {
    VAST_AD: 'vastAd',
    MEDIA_AD: 'mediaAd',
    ANDO_RUN_SPOT: 'andoRunSpot',
    TRITON_AD_PLATFORM: 'tap'
  };

  return adServerType;
});



//////////////////
// WEBPACK FOOTER
// ./src/base/ad/AdServerType.js
// module id = 32
// module chunks = 0